export default __webpack_public_path__ + "static/media/08_DAIF_WHY_DELL_04_02.d4bf797c.mp4";